export const TABS_RESCHEDULING = Object.freeze({
  ManagedByKiki: "managedByKiki",
  ManagedByCustomer: "managedByCustomer",
  AutomaticManagement: "automaticManagement",
  Incidents: "incidents",
  HistoryToReschedule: "historyToReschedule",
  Masiv: "masiv",
});

export const getPastBusinessDate = (startDate, days) => {
  let businessDaysCount = 0;
  let resultDate = new Date(startDate);

  while (businessDaysCount < days) {
    resultDate.setDate(resultDate.getDate() - 1);

    if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
      businessDaysCount++;
    }
  }

  return resultDate;
};

export const getMinDate = (tab, isClient = false) => {
  if (tab === TABS_RESCHEDULING.AutomaticManagement || isClient)
    return getPastBusinessDate(new Date(), 3);
  return null;
};
